export const BASE_PATH = process.env.REACT_APP_API_URL;
export const LOGIN_API = `/auth/login`;
export const FORGOT_API = `/auth/forgot-password`;
export const RESET_API = `/auth/reset-password?token=`;
export const VERIFICATION = `/auth/mfa`;
export const LOGOUT = `/auth/logout`;
export const RESEND_CODE = `/auth/mfa-resend`;
export const SIGN_UP_API = `/users/register`;
export const CHANGE_PASSWORD_API = `/auth/change-password`;
export const USER_DETAILS_API = `/users/user-details-customer`;
export const CHECK_EMAIL_EXIST = `/users/checkEmailExist`;
export const VERIFY_EMAIL_API = `/auth/verify-email?token=`;
export const STATE_LIST = `/auth/state-list`;
export const CHANGE_SIGNATURE = `/users/change-signature`;
export const INSPECTION_REQUEST = `/inspection-requests/add-request`;
export const MACHINE_LIST_API = `/users/machine-list`;
export const MACHINE_LIST_WITH_INPROGRESS_API = `/users/machine-list-inprogress`;
export const REFRESH_TOKEN = `/auth/refresh-tokens`;
export const CREATE_API = `/auth/create-password?token=`;
export const SR_DETAILS_API = `/inspection-requests/sr-inspection-details?id=`;
export const GET_CRITERIA_API = `/inspection-requests/get-inspection-criteria`;
export const GET_EQUIPMENT_DEVICE_API = `/inspection-requests/get-equipment`;
export const INSPECTION_UPDATE = `/inspector/inspection-update`;
export const GET_MACHINE_DATA = `/inspector/get-machine`;
export const GET_INSPECTION_SHEET_DATA = `/inspector/get-inspection-form-data`;
export const INSPECTION_SHEET_DATA_UPDATE = `/inspector/update-inspection-form-data`;
export const GET_INSPECTION_SHEET_FROM_EQUIPMENT_TYPE =
  "/inspector/inpsection-sheetFrom-equipment-type";
export const UPCOMING_INSPECTION = "/inspection-requests/upcoming-inspections";
export const GET_MACHINE_CONFIG = "/inspector/machine-config-deficiency";
export const ADD_DEFICIENCY = "/deficiency/createRedommendation";
export const GET_DEFICIENCY_DATA = "/deficiency/recommendationList";
export const UPDATE_DEFICIENCY_DATA = "/deficiency/recommendation-update";
export const DELETE_DEFICIENCY_DATA = "/deficiency/recommendation-delete";
export const DEFICIENCY_COMPLETE = "/deficiency/makeDeficiencyComplete";
export const TODAYS_INSPECTORS_INSPECTIONS =
  "/inspection-requests/inspector-todays-inspections";
export const UPCOMING_INSPECTORS_INSPECTIONS =
  "/inspection-requests/inspector-upcoming-inspections";
export const INSPECTOR_SR_DETAILS_API = `/inspection-requests/inspector-sr-inspection-details?id=`;
export const GOOGLE_MAP_URL = `https://www.google.com/maps/search/?api=1&query=`;
export const ADD_TRAVEL_INFORMATION = `/inspection-requests/add-travel-information`;
export const UPDATE_TRAVEL_INFORMATION = `/inspection-requests/update-travel-information`;
export const DELETE_TRAVEL_INFORMATION = `/inspection-requests/delete-travel-information`;
export const ADD_UPDATE_TRAVEL_INFORMATION_EXPENSES = `/inspection-requests/update-travel-information-expenses`;
export const INSEPCTED_MACHINES = `/inspection-requests/customer-inspected-machines`;
export const INSPECTOR_LIST = `/auth/inspector-list`;
export const INSEPCTED_MACHINES_DOCUMENT = `/inspection-requests/download-inspected-machine-document`;
export const INSEPCTED_MACHINES_CERTIFICATE = `/inspection-requests/download-inspected-machine-certificate`;
export const DOWNLOAD_INVOICE = `/invoice/download-invoice/`;
export const BILLS_AND_PAYMENTS = `/invoice/bills-and-payments`;
export const ADD_UPDATE_TRAVEL_INSPECTION_TIME = `/inspection-requests/update-travel-inspection-time`;
export const DEFICIENCY_UPDATE_CORRECTION_DATE =
  "/deficiency/updateCorrectionDate";
export const UPLOAD_SIGNATURE = "/deficiency/upload-signature";
export const DEFICIENCY_ISSUE_DOCUMENT = "/deficiency/deficiencyIssueDocument";
export const CUSTOMER_DASHBOARD_TILES = "/auth/customer-dashboard-tiles";
export const EXPIRATION_INSPECTION =
  "/inspection-requests/expiration-inspections";
export const CUSTOMER_DUE_INVOICES = "/invoice/due-invoices";
export const CUSTOMER_PENDING_DEFICIENCIES =
  "/inspection-requests/pending-deficiencies";
export const PREVIOUS_INSPECTORS_INSPECTIONS =
  "/inspection-requests/inspector-previous-inspections";
export const UPLOAD_MACHINE_IMAGES =
  "/inspection-requests/upload-machine-images";
export const GET_MACHINE_IMAGES = "/inspection-requests/machine-images";
export const DELETE_MACHINE_IMAGES =
  "/inspection-requests/delete-machine-image";
export const GET_LIST_OF_BOOM_JIB_CONSTRUCTION =
  "/inspector/list-of-boom-jib-construction";
export const DOWNLOAD_DEFICIENCY = `/inspection-requests/download-deficiency`;
export const SUB_USER_LIST = `/users/sub-users`;
export const ADD_SUB_USER = `/users/createSubUser`;
export const DELETE_SUB_USER = `/users/deleteUser`;
export const GET_CUSTOMER_SIGNATURE = "/deficiency/getCustomerSignature";

export const DOWNLOAD_APP_DOCUMENT = "/inspection-requests/downloadAllFiles";

export const CONTACT_US_QUERY = "/general/contact-us";
export const NOTIFICATION_LIST = `/auth/notification-list`;
export const NOTIFICATION_COUNT = `/auth/notification-count`;
export const READ_NOTIFICATION = `/auth/read-notification`;

export const MACHINE_EXISTS = `/inspection-requests/check-machine-exists`;
export const UPDATE_TRAVEL_NOTES = `/service-requests/update-travel-notes`;
export const SHARE_CERTIFICATE = `/certificate/shareCertificate`
export const ADD_MACHINE_IN_RUNNING_INSPECTION = "/inspector/add-machine-in-running-inspection";
export const MACHINE_HISTORY = `/service-requests/machine-history`
